import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetNotifierByIdFetchUrl,
  INotifierResponse,
} from "../../../../api/CircularEconomy/INotifiers";
import { RootState } from "../../../../redux/store";

export interface NotifierState {
  fetchStatus: string;
  error: any;
  NotifierResponse?: INotifierResponse;
}

const initialState: NotifierState = {
  error: undefined,
  fetchStatus: "Loading...",
  NotifierResponse: undefined,
};

export const loadNotifierAsync = createAsyncThunk(
  "notifier/load",
  async (notifierId: string) => {
    const response = await GetNotifierByIdFetchUrl(notifierId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const notifierSlice = createSlice({
  name: "notifier",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadNotifierAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadNotifierAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.NotifierResponse = action.payload;
      })
      .addCase(loadNotifierAsync.rejected, (state, action) => {
        state.fetchStatus = "rejected";
        state.error = action.payload;
      });
  },
});

export const selectNotifierResponse = (state: RootState) =>
  state.notifierResponse;

export default notifierSlice.reducer;
